import React from 'react';
import { SpottoHeader } from './SpottoHeader';

interface LegalDocumentLayoutProps {
  title: string;
  lastUpdated?: string;
  children: React.ReactNode;
}

export const LegalDocumentLayout: React.FC<LegalDocumentLayoutProps> = ({
  title,
  lastUpdated,
  children,
}) => {
  return (
    <div className="min-h-screen bg-surface-dark pt-16">
      {/* Shared Spotto top navigation */}
      <SpottoHeader />

      {/* Breadcrumb / back link — lands at the "About" section,
          where the legal links live in the landing footer */}
      <div className="max-w-4xl mx-auto px-6 pt-6">
        <a
          href="/#about"
          className="inline-flex items-center gap-1.5 text-sm text-ink-on-dark-muted hover:text-ink-on-dark transition-colors"
        >
          <span aria-hidden>←</span>
          Powrót do strony głównej
        </a>
      </div>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-6 pt-6 pb-12">
        <div className="bg-surface-dark-elevated rounded-2xl border border-white/[0.06] p-8 lg:p-12 shadow-xl">
          {/* Title */}
          <div className="text-center mb-10">
            <h1 className="font-display font-light tracking-tight text-3xl md:text-4xl text-ink-on-dark mb-4 whitespace-pre-line">
              {title}
            </h1>
            <div className="w-16 h-px bg-brand-primary/60 mx-auto" />
          </div>

          {/* Content */}
          <div className="space-y-6">
            {children}
          </div>

          {/* Last updated footnote */}
          {lastUpdated && (
            <div className="mt-12 pt-6 border-t border-white/[0.06] text-center">
              <p className="font-mono text-xs uppercase tracking-[0.2em] text-ink-on-dark-muted">
                Ostatnia aktualizacja: {lastUpdated}
              </p>
            </div>
          )}
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-white/[0.06] bg-surface-dark">
        <div className="max-w-4xl mx-auto px-6 py-6 text-center">
          <p className="text-xs text-ink-on-dark-muted/70">
            © {new Date().getFullYear()} Solid Labs PSA. Wszystkie prawa zastrzeżone.
          </p>
        </div>
      </footer>
    </div>
  );
};
